// Delete Lookbook
export const DELETE_LOOKBOOK_REQUEST = 'DELETE_LOOKBOOK_REQUEST';
export const DELETE_LOOKBOOK_DONE = 'DELETE_LOOKBOOK_DONE';
export const DELETE_LOOKBOOK_FAILED = 'DELETE_LOOKBOOK_FAILED';
